// Cooley Program Variables
export const cooleyVariables: any = {
    programTitle: "Cooley LLP",
    effectiveDates: "10/1/2025 - 10/1/2026",
    feeDisclaimer: "All Premiums are subject to 3% California Surplus Lines Tax and 0.18% Stamping Fee (not included in below premiums).",
    EL_Items: [
        "Cooley_EL_Header",
        ["Cooley_EL_1M", "$1,000,000", "$1,012"],
        ["Cooley_EL_2M", "$2,000,000", "$1,362"],
        ["Cooley_EL_3M", "$3,000,000", "$1,577"],
        ["Cooley_EL_5M", "$5,000,000", "$2,017"],
        ["Cooley_EL_10M", "$10,000,000", "$3,247"],
        ["Cooley_EL_15M", "$15,000,000*", "$6,458"]
    ],
    EL_Disclaimers: [
        "<strong>*</strong>The maximum limit of liability for any participants without their underlying home and auto insurance policies in place with Chubb",
        `<strong>**</strong>It is a requirement that any participant who <u>newly elects or enrolls</u> at these limits have their underlying home and auto insurance policies in place with Chubb and complete the Group Personal Excess Participants Questionnaire. This limit is subject to prior underwriting approval. These requirements have been waived for current participants renewing at their expiring limit.`

    ],
    UM_Items: [
        "Cooley_UM_Header",
        ["Cooley_UM_1M", "$1,000,000", "Included above"],
        ["Cooley_UM_2M", "$2,000,000", "$164"],
        ["Cooley_UM_3M", "$3,000,000", "$384"],
        ["Cooley_UM_5M", "$5,000,000", "$1,024"]
    ],
    UM_Disclaimers: ["*The UM/UIM limit cannot be higher than the liability limit."],
    EPLI_Items: [
        "Cooley_EP_Header",
        ["Cooley_EP_Decline", "By selecting this box, I am declining EPLI Insurance."],
        ["Cooley_EP_250K", "$250,000 per occurrence / $500,000 aggregate*", "$10,000", "$1,098"]
    ],
    EPLI_Disclaimer: "<strong>*</strong>*Any participant who newly <u>elects</u> this coverage is required to complete the Chubb Employment Practice Liability Coverage Request Worksheet.",
    CI_Items: [
        "Cooley_PR_Parent",
        "Cooley_PR_Yes",
        "Cooley_PR_No"
    ]
};

